import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

const newsItems = [
  {
    id: '25',
    title: 'Adding a Donation to your Order',
    slug: 'adding-a-donation-to-your-order',
    excerpt: 'We have now added an option to WebCollect to allow you to include your donation for the collection along with your event booking.',
    date: '2025-01-15',
    category: 'WebCollect',
  },
  {
    id: '17',
    title: 'Adding a Subscription on WebCollect',
    slug: 'adding-a-subscription-on-webcollect',
    excerpt: 'After creating a password and verifying your account, if you are required to pay an Annual Subscription you must add this to your account.',
    date: '2024-09-01',
    category: 'WebCollect',
  },
];

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

const NewsPage = () => {
  return (
    <div className="p-6 md:p-12 lg:p-16" data-testid="news-page">
      <div className="max-w-4xl">
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          News
        </h1>

        <p className="text-lg text-gray-700 leading-relaxed mb-8">
          Stay up to date with the latest announcements and updates from St David (University Lodge) No. 36.
        </p>

        {/* News List */}
        <div className="space-y-6" data-testid="news-list">
          {newsItems.map((item) => (
            <Card 
              key={item.id} 
              className="border-gray-100 hover:shadow-md transition-shadow"
              data-testid={`news-item-${item.id}`}
            >
              <CardHeader className="pb-2">
                <div className="flex items-start justify-between gap-4">
                  <CardTitle className="font-heading text-xl font-semibold text-gray-900">
                    {item.title}
                  </CardTitle>
                  <Badge variant="secondary" className="flex-shrink-0">
                    {item.category}
                  </Badge>
                </div>
                <p className="text-sm text-gray-500" data-testid={`news-date-${item.id}`}>
                  {formatDate(item.date)}
                </p>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">{item.excerpt}</p>
                <a
                  href={`https://stdaviduniversitylodge.org.uk/news/${item.id}-${item.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-emerald-600 hover:text-emerald-700 font-medium text-sm transition-colors"
                  data-testid={`news-link-${item.id}`}
                >
                  Read more →
                </a>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* WebCollect Info */}
        <section className="mt-10" data-testid="webcollect-info">
          <Card className="bg-gradient-to-br from-gray-50 to-white border-gray-100">
            <CardContent className="p-6 md:p-8">
              <h3 className="font-heading text-xl font-semibold text-gray-900 mb-3">
                About WebCollect
              </h3>
              <p className="text-gray-700 mb-4">
                WebCollect is our membership management system used for event bookings, subscriptions, 
                and dues payments. Members can access the WebCollect portal after logging in to the 
                Members Area.
              </p>
              <p className="text-sm text-gray-500">
                Note: WebCollect login is only available to registered members.
              </p>
            </CardContent>
          </Card>
        </section>
      </div>
    </div>
  );
};

export default NewsPage;
